'use client';

import clsx from 'clsx';

import type { ChatMessage } from '../../types/ChatMessage';
import { MessageBubbleShell } from './MessageBubbleShell';

interface Props {
  message: ChatMessage;
  isOwn: boolean;
}

/**
 * Fallback bubble for message types this client doesn't render
 * (order / product / post / system, plus anything novel the server
 * adds later). Uses an italic, opacity-muted variant of the
 * direction's normal text color so contrast stays legible on both
 * mint (own) and neutral (received) backgrounds — flat
 * `text-content-2` washed out against the mint bg.
 */
export function UnsupportedMessage({ message, isOwn }: Props) {
  return (
    <MessageBubbleShell message={message} isOwn={isOwn}>
      <div
        className={clsx(
          'px-3.5 py-2 text-sm italic',
          isOwn
            ? 'bg-brand text-sink/60 theme-light:text-content-on-brand/60'
            : 'bg-surface-3 text-raise/60',
        )}
      >
        Unsupported message
      </div>
    </MessageBubbleShell>
  );
}
